export default __webpack_public_path__ + "static/eventImg4-846073dc0d8ecfa9e639e8058ffbafc5.svg";